import type { RouteObject } from "react-router-dom";

export const reclaimDisputesRoutes: RouteObject[] = [
  {
    handle: { breadcrumb: "Reclaim Disputes Monitor" },
    async lazy() {
      const { Page } = await import("../app/page");
      return { element: <Page /> };
    },
    children: [
      {
        index: true,
        async lazy() {
          const { ReclaimDisputesMonitorPage } = await import(
            "./reclaim-disputes-monitor-page"
          );
          return { Component: ReclaimDisputesMonitorPage };
        },
      },
    ],
  },
];
